import { useId } from "@mantine/hooks"
import React, { ComponentProps } from "react"
import classNames from "utils/classNames"
import styles from "./styles.module.scss"
type IFrameProps = ComponentProps<"iframe"> & {
  className?: any
}
const IFrame = ({ src, title, className, ...props }: IFrameProps) => {
  const uuid = useId()
  return (
    <iframe
      title={title || uuid}
      src={src}
      className={classNames(styles["base"], className)}
      {...props}
    />
  )
}

export default IFrame
